import React from "react";
import GoogleCalendarPopup from "./Calendar";
import "../css/Services.css";

const Services = () => {
  return (
    <div className="services">
      <div className="services__header">
        <h1>Pharmacy Services</h1>
        <p className="services__description">
          Our pharmacy services offer a wide range of medications and
          consultations with knowledgeable pharmacists to ensure you receive the
          best care for your health needs.
        </p>
      </div>

      <div className="services__booking">
        <GoogleCalendarPopup />
      </div>

      <div className="services__section">
        <h2>NHS Services</h2>
        <ul className="services__list">
          <li>Free Blood Pressure Check</li>
          <li>Free Oral Contraception Service</li>
          <li>Free Emergency Contraception
            <br />
            (morning after pill / plan B)
          </li>
          <li>Electronic Prescription Service</li>
          <li>New Medicine Service</li>
          <li>
            Flu Vaccination
            <br />
            <small className="services__note">
              (Must be booked through this{" "}
              <a
                href="https://www.nhs.uk/nhs-services/vaccination-and-booking-services/book-flu-vaccination/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>NHS website</strong>
              </a>
              )
            </small>
          </li>
          <li>
            COVID-19 Vaccination
            <br />
            <small className="services__note">
              (Must be booked through this{" "}
              <a
                href="https://www.nhs.uk/nhs-services/vaccination-and-booking-services/book-flu-vaccination/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>NHS website</strong>
              </a>
              )
            </small>
          </li>
          <li>
            Men B Vaccination
            <br />
            <small className="services__note">
              (Must be booked through this{" "}
              <a
                href="https://www.nhs.uk/nhs-services/vaccination-and-booking-services/book-a-menb-vaccination-appointment/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>NHS website</strong>
              </a>
              )
            </small>
          </li>
        </ul>
      </div>

      <div className="services__section">
        <h2>NHS Pharmacy First</h2>
        <p>
          These services are funded by the NHS and are available to patients
          within the age range specified.
        </p>
        <ul className="services__list">
          <li>Earache (1 - 17 years old)</li>
          <li>Impetigo (&gt; 1 year old)</li>
          <li>Infected Insect Bites (&gt; 1 year old)</li>
          <li>Shingles (&gt; 18 years old)</li>
          <li>Sinusitis (&gt; 12 years old)</li>
          <li>Sore Throat (&gt; 5 years old)</li>
          <li>Urinary Tract Infection (Women only 16 - 64 years old)</li>
        </ul>
      </div>

      <div className="services__section">
        <h2>Private Services</h2>
        <ul className="services__list">
          <li>Private Flu Vaccination</li>
          <li>
            Private COVID-19 Vaccination
            <br />
            <small className="services__note">(Please kindly call to enquire)</small>
          </li>
          <li>
            Private Men B Vaccination
            <br />
            <small className="services__note">(Please kindly call to enquire)</small>
          </li>
          <li>Private Prescription Dispensing</li>
          <li>Emergency Hormonal Contraception</li>
          <li>Period Delay Service</li>
        </ul>
      </div>
    </div>
  );
};

export default Services;
